import { render, staticRenderFns } from "./CartInfo.vue?vue&type=template&id=6db23c97&"
import script from "./CartInfo.vue?vue&type=script&lang=js&"
export * from "./CartInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports